import React, { useRef, useEffect } from 'react';
import ThreeLineLayer from './ThreeLineLayer';
import { useUpdateEffect } from 'ahooks';
import { registerEventLayer } from '../events';
import useProps from '../_util/useProps';

export default function(props) {
    const {
        data,
        id: key,
        _key,
        show = true,
        layerControl = true,
        ...otherProps
    } = props;
    const layerRef = useRef();
    const { map } = useProps();

    useEffect(() => {
        let layer = new ThreeLineLayer({
            data,
            key: key || _key,
            name,
            show,
            map,
            layerControl,
            ...otherProps
        });

        // 注册事件
        layer.loaded = (primitives) => {
            primitives.forEach((item) => {
                registerEventLayer(item, props);
            })
        }

        layerRef.current = layer;
        return () => {
            layerRef.current.destroy()
        };
    }, []);

    useUpdateEffect(() => {
        layerRef.current.loadData(data);
    }, [JSON.stringify(data)]);

    useUpdateEffect(() => {
        layerRef.current.show = show;
    }, [show]);

    return <></>;
}
